// Extract a YouTube video id from the various URL forms a merchant might paste. Returns null when
// the URL isn't a recognizable YouTube link (e.g. a direct .mp4). Moved out of HomePage so both the
// legacy section-cell video renderer and the new VideoSection share one implementation.
export function extractYouTubeVideoId(url: string): string | null {
    if (!url) return null;
    // Standard watch URLs (?v=VIDEO_ID)
    const watchMatch = url.match(/[?&]v=([\w-]{11})/);
    if (watchMatch) return watchMatch[1];
    // Embed URLs (/embed/VIDEO_ID)
    const embedMatch = url.match(/\/embed\/([\w-]{11})/);
    if (embedMatch) return embedMatch[1];
    // Short URLs (youtu.be/VIDEO_ID)
    const shortMatch = url.match(/youtu\.be\/([\w-]{11})/);
    if (shortMatch) return shortMatch[1];
    // Direct youtube.com/VIDEO_ID
    const directMatch = url.match(/youtube\.com\/([\w-]{11})/);
    if (directMatch) return directMatch[1];
    return null;
}
